import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=12685454&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=12685454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12685454",
  null
  
)

export default component.exports